const aboutItems = (texts: any) => {
  return {
    quote: texts?.quote || "",
    points: texts?.desc || [],
  };
};

export default aboutItems;
